import React from 'react';
import { Outlet } from 'react-router-dom';

import { isMobile } from 'utils/mobileDetector';

import './OnboardingLayout.pcss';

type Props = {
  children?: React.ReactNode;
};

export const OnboardingLayout: React.FC<Props> = ({ children }) => (
  <div className={`OnboardingLayout ${isMobile() ? 'mobile' : ''}`}>
    <Outlet />
  </div>
);
